// redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import loading  from './slice/slice';

export const store = configureStore({
  reducer: {
    loading: loading,
  },
});
export type Loadingstate = ReturnType<typeof store.getState>

export default store;
